import React from 'react';
import { Button } from './ui/button';
import { Instagram, Mail, Phone } from 'lucide-react';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="container">
          <div className="hero-text">
            <div className="hero-title-wrapper">
              <div className="hero-avatar-wrapper">
                <img 
                  src="https://customer-assets.emergentagent.com/job_kozlowski-fit/artifacts/vatwc7vo_6982b78e-8965-4993-bdac-c615559b3fd3-removebg-preview.png" 
                  alt="Paweł Kozłowski - Logo"
                  className="hero-avatar"
                />
              </div>
              <h1 className="hero-title">
                Paweł Kozłowski
              </h1>
            </div>
            <p className="hero-subtitle">
              Trener Personalny | Dietetyk | Doradca Osobisty i Online
            </p>
            <p className="hero-tagline">
              Osiągnij swoje cele fitness z indywidualnym podejściem i profesjonalnym wsparciem
            </p>
            <div className="hero-cta">
              <Button 
                className="btn-cta"
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              >
                Umów Trening
              </Button>
              <div className="hero-price">
                <span className="price-label">Trening personalny od</span>
                <span className="price-value">80 zł</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-social">
        <a href="https://www.instagram.com/trener.kozlowski.89" target="_blank" rel="noopener noreferrer" className="social-link">
          <Instagram size={24} />
        </a>
      </div>
    </section>
  );
};

export default Hero;
